import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Col, Form, Modal, Row, Image, Button } from 'react-bootstrap';
import {
  OutlinedInput,
  FormControl,
  InputLabel,
  Select,
  makeStyles,
  IconButton,
  MenuItem,
} from '@material-ui/core';
import { ReusableOnboardingButton } from '../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton';
import { TopTextReusableComponent } from '../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent';
import { NewInputText } from '../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { AddButtonIconComponent } from '../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Alert from 'react-s-alert';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { update_item_menu_setup } from '../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction';
import Media from 'react-media';
import {
  admin_uom_ratio_filter_search,
  admin_uom_ratio_filter_searchTwo,
} from '../../../../../../../../store/actions/SuperAdminActions/superAdminUOMAction';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: '100%',
    marginBottom: '1rem',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const SizePricing = (props) => {
  const classes = useStyles();

  const back = () => {
    props.onChange(5);
    window.scroll(0, 0);
  };
  const onClickBack = () => {
    let formData = {};
    const token = props.auth.user.accessToken;
    if (
      props.menuCategoryItems.currentState !== 9 ||
      props.menuCategoryItems.runingTrack !== 9
    ) {
      formData.currentState = 4;
      formData.runingTrack = 5;
    }

    props.update_item_menu_setup(props.activeItemId, formData, token, back);
  };
  // const onSubmit = () => {
  //   //props.onChange(4);
  //   window.scroll(0, 0);
  // };
  const [state, setState] = useState({
    UoM: '',
  });
  const selecthandleChange = (e) => {
    setState({
      UoM: e.target.value,
    });
    formikCustom.setFieldValue('uom', e.target.value);
    formik.setFieldValue('sizes[0].uom', e.target.value);
  };
  const [deleteIndex, setDeleteIndex] = useState();

  const [showDeleteModal, onShowDeleteModal] = useState(false);

  const onClickDeleteIcon = (e, id) => {
    e.preventDefault();
    setDeleteIndex(id);
    onShowDeleteModal(true);
  };
  const handleDeleteModal = (e) => {
    e.preventDefault();
    let updateDeleted = formik.values.size.filter((item, index) => {
      return index !== deleteIndex;
    });
    let foundDefault = true;
    let defaultData = updateDeleted;
    if (defaultData.length !== 0) {
      for (let i = 0; i < updateDeleted.length; i++) {
        if (updateDeleted.isDefault) {
          break;
        } else {
          foundDefault = false;
        }
      }
      if (!foundDefault && defaultData.length > 0) {
        defaultData[0].isDefault = true;
        defaultData[0].available = true;
      }
    }
    formik.setFieldValue('size', defaultData);
    onShowDeleteModal(false);
  };
  const handleCloseDeleteModal = () => onShowDeleteModal(false);

  const [showDetails, setShowDetails] = useState(false);
  const handleShowDetails = () => setShowDetails(true);
  const handleCloseDetails = () => setShowDetails(false);

  var flagCall = false;

  const validate = (values) => {
    const errors = {};

    if (
      (formik.values.itemSize === 'MULTIPLE' ||
        formik.values.itemSize === 'CUSTOM') &&
      flagCall === true
    ) {
      if (!values.description) {
        errors.description = 'Please enter size description';
      }
      // if (!values.calories) {
      //   errors.calories = "Please enter calories";
      // }
      if (!values.price) {
        errors.price = 'Please enter price';
      }
      if (!values.pax) {
        errors.pax = 'Please enter pax';
      }
      // if (!values.size) {
      //   errors.size = "Please enter size";
      // }
      // if (!values.uom) {
      //   errors.uom = "Please select uom";
      // }
    } else if (formik.values.itemSize === 'SINGLE') {
      if (values.sizes && values.sizes[0] && !values.sizes[0].price) {
        errors.price = 'Please enter price';
      }
      // if (values.sizes && values.sizes[0] && !values.sizes[0].calories) {
      //   errors.calories = "Please enter calories";
      // }
      if (values.sizes && values.sizes[0] && !values.sizes[0].pax) {
        errors.pax = 'Please enter pax';
      }
      // if (values.sizes && values.sizes[0] && !values.sizes[0].size) {
      //   errors.size = "Please enter size";
      // }
      // if (values.sizes && values.sizes[0] && !values.sizes[0].uom) {
      //   errors.uom = "Please select uom";
      // }
    }

    return errors;
  };

  const onClickAddNew = (e) => {
    flagCall = true;
    e.preventDefault();
    formikCustom.handleSubmit();
  };

  const onChangeAvaiblity = (status, id) => {
    let updateAvailable = formik.values.size.map((item, index) => {
      if (index === id) {
        return { ...item, available: !status };
      } else {
        return { ...item };
      }
    });
    formik.setFieldValue('size', updateAvailable);
  };

  const onChangeDefault = (id) => {
    let defaultStatus = formik.values.size.map((item, index) => {
      if (index === id) {
        return { ...item, isDefault: true };
      } else {
        return { ...item, isDefault: false };
      }
    });
    formik.setFieldValue('size', defaultStatus);
  };

  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);

  const onEditItem = (index, item) => {
    formikCustom.setFieldValue('price', item.price);
    formikCustom.setFieldValue('calories', item.calories);
    formikCustom.setFieldValue('pax', item.pax);
    formikCustom.setFieldValue('size', item.size);
    formikCustom.setFieldValue('alcoholContent', item.alcoholContent);
    formikCustom.setFieldValue('uom', item.uom);

    formikCustom.setFieldValue(
      'mainUnitMatricServingPax',
      item.mainUnitMatricServingPax
    );
    formikCustom.setFieldValue('mainUnitMatricUOM', item.mainUnitMatricUOM);
    formikCustom.setFieldValue(
      'mainUnitImperialServingPax',
      item.mainUnitImperialServingPax
    );
    formikCustom.setFieldValue('mainUnitImperialUOM', item.mainUnitImperialUOM);
    formikCustom.setFieldValue(
      'alternateUnitMatricServingPax',
      item.alternateUnitMatricServingPax
    );
    formikCustom.setFieldValue(
      'alternateUnitMatricUOM',
      item.alternateUnitMatricUOM
    );
    formikCustom.setFieldValue(
      'alternateUnitImperialServingPax',
      item.alternateUnitImperialServingPax
    );
    formikCustom.setFieldValue(
      'alternateUnitImperialUOM',
      item.alternateUnitImperialUOM
    );
    formikCustom.setFieldValue('alternateUnitArr', item.alternateUnitArr);
    formikCustom.setFieldValue('description', item.description);
    setState({
      ...state,
      UoM: item.uom,
    });
    setIsEdit(true);
    setEditData([
      { id: index, available: item.available, isDefault: item.isDefault },
    ]);
    handleCloseDetails();
  };

  const formikCustom = useFormik({
    initialValues: {
      price: '',
      pax: '',
      calories: '',
      size: '',
      uom: '',
      description: '',
      alcoholContent: '',
      isDefault: false,
      available: true,
      /******* New Field ******/
      mainUnitMatricServingPax: '',
      mainUnitMatricUOM: '',
      mainUnitImperialServingPax: '',
      mainUnitImperialUOM: '',
      ////////////////////////////
      alternateUnitMatricServingPax: '',
      alternateUnitMatricUOM: '',
      alternateUnitImperialServingPax: '',
      alternateUnitImperialUOM: '',
      alternateUnitArr: [],
    },
    validate,

    onSubmit: (values) => {
      if (!isEdit) {
        let sizeData = formik.values.size;
        if (sizeData.length === 0) {
          values.isDefault = true;
        }
        sizeData.push(values);
        formik.setFieldValue('size', sizeData);
      } else {
        values.available = editData[0].available;
        values.isDefault = editData[0].isDefault;
        formik.setFieldValue(`size[${editData[0].id}]`, values);
        setIsEdit(false);
        setEditData([]);
      }
      setState({
        ...state,
        UoM: '',
      });
      formikCustom.resetForm();
      formikCustom.setFieldValue('alternateUnitArr', []);
    },
  });

  const titleCase = (str, name) => {
    str = str.toLowerCase().split(' ');
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return formikCustom.setFieldValue(name, str.join(' '));
  };

  const OnClickNextStep = (e) => {
    e.preventDefault();
    flagCall = false;
    formik.handleSubmit();
  };

  const onSuccess = () => {
    props.onChange(7);
    window.scroll(0, 0);
    return ;
    
    if (props.activeItemData.productClassification === 'Food & Beverage') {
      props.onChange(8);
    } else {
      if (props?.nutrition_information) {
        props.onChange(7);
      } else {
        props.onChange(8);
      }
    }
    window.scroll(0, 0);
  };

  const information = useSelector((state) => {
    return {
      personalization_information:
        state.onboarding.restaurantDetails.personalization_information,
      allergic_information:
        state.onboarding.restaurantDetails.allergic_information,
      nutrition_information:
        state.onboarding.restaurantDetails.nutrition_information,
    };
  });

  const formik = useFormik({
    initialValues: {
      itemSize: '',
      sizes: [
        {
          price: '',
          calories: '',
          pax: '',
          size: '',
          uom: '',
          alcoholContent: '',
          isDefault: true,
          available: true,
          /******* New Field ******/
          mainUnitMatricServingPax: '',
          mainUnitMatricUOM: '',
          mainUnitImperialServingPax: '',
          mainUnitImperialUOM: '',
          ////////////////////////////
          alternateUnitMatricServingPax: '',
          alternateUnitMatricUOM: '',
          alternateUnitImperialServingPax: '',
          alternateUnitImperialUOM: '',
          alternateUnitArr: [],
        },
      ],
      size: [],
      catering_banquet: {
        value: false,
        sizes: [],
        sur_charges_value: false,
        sur_charges: [],
      },
      home_delivery: {
        value: false,
        sizes: [],
        sur_charges_value: false,
        sur_charges: [],
      },
    },
    validate,
    validationSchema: yup.object({
      itemSize: yup.string().required('Please select size'),
      //size: yup.array().min(1),
      // size: yup.array().of(
      //   yup.object().shape({
      //     price: yup.string().required("Please enter price"),
      //   })
      // ),
    }),
    onSubmit: (values) => {
      let formData = {};
      if (values.itemSize === 'SINGLE') {
        values.size = values.sizes;
      }
      if (values.size.length < 1) {
        Alert.error(`<h4> Please add atleast one item size</h4>`, {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        // /delete values.sizes;
        formData.itemSize = values.itemSize;
        formData.size = values.size;
        // formData.catering_banquet = values.catering_banquet;
        // formData.home_delivery = values.home_delivery;

        const token = props.auth.user.accessToken;
        // if(props.menuCategoryItems.currentState !== 9 ||
        //   props.menuCategoryItems.runingTrack !== 9){
        //   formData.currentState = 6;
        //   formData.runingTrack = 7;
        // }

        if (
          props.menuCategoryItems.currentState !== 9 ||
          props.menuCategoryItems.runingTrack !== 9
        ) {
          if (information.nutrition_information) {
            formData.currentState = 6;
            formData.runingTrack = 7;
          } else {
            if (values.itemSize === 'CUSTOM') {
              formData.currentState = 6;
              formData.runingTrack = 8;
            } else {
              formData.currentState = 6;
              formData.runingTrack = 9;
            }
          }
        }
        // console.log("formData ==>", formData);
        props.update_item_menu_setup(
          props.activeItemId,
          formData,
          token,
          onSuccess
        );
      }
    },
  });

  // const clearForm = (e) => {
  //   e.preventDefault();
  //   formikCustom.resetForm();
  // };

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      let data = props.menuCategoryItems;
      if (
        (data.catering_banquet == undefined && data.catering_banquet == null) ||
        (data.home_delivery == undefined && data.home_delivery == null)
      ) {
        formik.setFieldValue('catering_banquet.sizes', data?.size);
        formik.setFieldValue('home_delivery.sizes', data?.size);
      }
      if (data.itemSize !== undefined) {
        formik.setFieldValue('itemSize', data.itemSize);
        if (data.itemSize === 'SINGLE') {
          formik.setFieldValue('sizes', data.size);
        } else {
          formik.setFieldValue('size', data.size);
        }
        setState({ UoM: data.size[0].uom });
      }
    }
  }, [props.menuCategoryItems]);

  useEffect(() => {
    setState({
      UoM: '',
    });
  }, []);

  const [majourClassification, setMajourClassification] = useState('');
  const [shortCode, setShortCode] = useState('');
  const onChangeuUomMatric = (e, data, actionBy) => {
    const token = props.auth.user.accessToken;
    if (
      majourClassification === data.major_classification &&
      shortCode === data?.short_code
    ) {
      if (actionBy === 'ONESIZE') {
        formik.setFieldValue('sizes[0].mainUnitImperialServingPax', 0);
        formik.setFieldValue('sizes[0].mainUnitImperialUOM', '');
      } else {
        formikCustom.setFieldValue('mainUnitImperialServingPax', 0);
        formikCustom.setFieldValue('mainUnitImperialUOM', '');
      }
    } else {
      props.admin_uom_ratio_filter_search(
        token,
        1,
        100,
        true,
        onSuccessFilterData(data),
        'ACTIVE',
        data?.major_classification,
        data?.short_code
      );
    }
  };
  const onSuccessFilterData = (data) => () => {
    setMajourClassification(data.major_classification);
    setShortCode(data?.short_code);
    formik.setFieldValue('sizes[0].mainUnitImperialServingPax', 0);
    formik.setFieldValue('sizes[0].mainUnitImperialUOM', '');
    formikCustom.setFieldValue('mainUnitImperialServingPax', 0);
    formikCustom.setFieldValue('mainUnitImperialUOM', '');
  };

  const [majourClassificationAUOM, setMajourClassificationAUOM] = useState('');
  const [shortCodeAUOM, setShortCodeAUOM] = useState('');
  const onChangeuAuomMatric = (e, data, actionBy) => {
    const token = props.auth.user.accessToken;
    if (
      majourClassificationAUOM === data.major_classification &&
      shortCodeAUOM === data?.short_code
    ) {
      if (actionBy === 'ONESIZE') {
        formik.setFieldValue('sizes[0].alternateUnitImperialServingPax', 0);
        formik.setFieldValue('sizes[0].alternateUnitImperialUOM', '');
      } else {
        formikCustom.setFieldValue('alternateUnitImperialServingPax', 0);
        formikCustom.setFieldValue('alternateUnitImperialUOM', '');
      }
    } else {
      props.admin_uom_ratio_filter_searchTwo(
        token,
        1,
        100,
        true,
        onSuccessAUOMFilterData(data),
        'ACTIVE',
        data?.major_classification,
        data?.short_code
      );
    }
  };
  const onSuccessAUOMFilterData = (data) => () => {
    setMajourClassificationAUOM(data.major_classification);
    setShortCodeAUOM(data?.short_code);
    formik.setFieldValue('sizes[0].alternateUnitImperialServingPax', 0);
    formik.setFieldValue('sizes[0].alternateUnitImperialUOM', '');
    formikCustom.setFieldValue('alternateUnitImperialServingPax', 0);
    formikCustom.setFieldValue('alternateUnitImperialUOM', '');
  };

  const onChangeuUomImperial = (e, data, actionBy) => {
    e.preventDefault();
    let c_Form_Value = data.conversion_from_value;
    let c_To_Value = data.conversion_to_value;
    let uom_Matric_Value = formik.values?.sizes[0]?.mainUnitMatricServingPax;
    let uom_Matric_Value1 = formikCustom.values?.mainUnitMatricServingPax;
    let finalValue = c_Form_Value * c_To_Value * uom_Matric_Value;
    let finalValue1 = c_Form_Value * c_To_Value * uom_Matric_Value1;
    if (actionBy === 'ONESIZE') {
      formik.setFieldValue('sizes[0].mainUnitImperialServingPax', finalValue);
    } else {
      formikCustom.setFieldValue('mainUnitImperialServingPax', finalValue1);
    }
  };

  const onChangeuAomImperial = (e, data, actionBy) => {
    e.preventDefault();
    let c_Form_Value = data.conversion_from_value;
    let c_To_Value = data.conversion_to_value;
    let aom_Matric_Value =
      formik.values?.sizes[0]?.alternateUnitMatricServingPax;
    let aom_Matric_Value1 = formikCustom.values?.alternateUnitMatricServingPax;
    let finalValue = c_Form_Value * c_To_Value * aom_Matric_Value;
    let finalValue1 = c_Form_Value * c_To_Value * aom_Matric_Value1;
    if (actionBy === 'ONESIZE') {
      formik.setFieldValue(
        'sizes[0].alternateUnitImperialServingPax',
        finalValue
      );
    } else {
      formikCustom.setFieldValue(
        'alternateUnitImperialServingPax',
        finalValue1
      );
    }
  };

  const onResetPreviousData = (info) => {
    let itemData = [
      {
        price: '',
        calories: '',
        pax: '',
        size: '',
        uom: '',
        alcoholContent: '',
        isDefault: true,
        available: true,
        /******* New Field ******/
        mainUnitMatricServingPax: '',
        mainUnitMatricUOM: '',
        mainUnitImperialServingPax: '',
        mainUnitImperialUOM: '',
        ////////////////////////////
        alternateUnitMatricServingPax: '',
        alternateUnitMatricUOM: '',
        alternateUnitImperialServingPax: '',
        alternateUnitImperialUOM: '',
        alternateUnitArr: [],
      },
    ];
    let itemSizeArr = [];
    if (info !== formik.values.itemSize) {
      formik.setFieldValue('sizes', itemData);
      formik.setFieldValue('size', itemSizeArr);
    }
  };

  const alternateUnitSave = (e) => {
    let itemSize = formik.values.itemSize;
    let oneSizeValue = formik.values?.sizes?.[0];
    let multipleSizeValue = formikCustom.values;
    let alternateUnitArr =
      itemSize === 'SINGLE'
        ? oneSizeValue?.alternateUnitArr
        : multipleSizeValue?.alternateUnitArr;
    let formData = {
      alternateUnitMatricServingPax:
        itemSize === 'SINGLE'
          ? oneSizeValue?.alternateUnitMatricServingPax
          : multipleSizeValue?.alternateUnitMatricServingPax,
      alternateUnitMatricUOM:
        itemSize === 'SINGLE'
          ? oneSizeValue?.alternateUnitMatricUOM
          : multipleSizeValue?.alternateUnitMatricUOM,
      alternateUnitImperialServingPax:
        itemSize === 'SINGLE'
          ? oneSizeValue?.alternateUnitImperialServingPax
          : multipleSizeValue?.alternateUnitImperialServingPax,
      alternateUnitImperialUOM:
        itemSize === 'SINGLE'
          ? oneSizeValue?.alternateUnitImperialUOM
          : multipleSizeValue?.alternateUnitImperialUOM,
    };
    if (itemSize === 'SINGLE') {
      if (
        oneSizeValue?.alternateUnitMatricServingPax === '' ||
        oneSizeValue?.alternateUnitMatricUOM == '' ||
        oneSizeValue?.alternateUnitImperialServingPax === '' ||
        oneSizeValue?.alternateUnitImperialUOM == ''
      ) {
        Alert.error(`<h4>Please fill all the field</h4>`, {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        if (
          alternateUnitArr.find(
            (data, index) =>
              data.alternateUnitMatricServingPax ===
                oneSizeValue?.alternateUnitMatricServingPax &&
              data.alternateUnitMatricUOM ===
                oneSizeValue?.alternateUnitMatricUOM &&
              data.alternateUnitImperialServingPax ===
                oneSizeValue?.alternateUnitImperialServingPax &&
              data.alternateUnitImperialUOM ===
                oneSizeValue?.alternateUnitImperialUOM
          )
        ) {
          Alert.error(`<h4>Record already exists</h4>`, {
            position: 'top-right',
            effect: 'bouncyflip',
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else if (oneSizeValue?.alternateUnitArr?.length <= 0) {
          alternateUnitArr.push(formData);
          formik.setFieldValue('sizes[0].alternateUnitArr', alternateUnitArr);
          formik.setFieldValue('sizes[0].alternateUnitMatricServingPax', '');
          formik.setFieldValue('sizes[0].alternateUnitMatricUOM', '');
          formik.setFieldValue('sizes[0].alternateUnitImperialServingPax', '');
          formik.setFieldValue('sizes[0].alternateUnitImperialUOM', '');
        } else {
          alternateUnitArr[0] = formData;
          formik.setFieldValue('sizes[0].alternateUnitArr', alternateUnitArr);
          formik.setFieldValue('sizes[0].alternateUnitMatricServingPax', '');
          formik.setFieldValue('sizes[0].alternateUnitMatricUOM', '');
          formik.setFieldValue('sizes[0].alternateUnitImperialServingPax', '');
          formik.setFieldValue('sizes[0].alternateUnitImperialUOM', '');
        }
      }
    } else {
      if (
        multipleSizeValue?.alternateUnitMatricServingPax === '' ||
        multipleSizeValue?.alternateUnitMatricUOM == '' ||
        multipleSizeValue?.alternateUnitImperialServingPax === '' ||
        multipleSizeValue?.alternateUnitImperialUOM == ''
      ) {
        Alert.error(`<h4>Please fill all the field</h4>`, {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        if (
          alternateUnitArr.find(
            (data, index) =>
              data?.alternateUnitMatricServingPax ===
                multipleSizeValue?.alternateUnitMatricServingPax &&
              data?.alternateUnitMatricUOM ===
                multipleSizeValue?.alternateUnitMatricUOM &&
              data?.alternateUnitImperialServingPax ===
                multipleSizeValue?.alternateUnitImperialServingPax &&
              data?.alternateUnitImperialUOM ===
                multipleSizeValue?.alternateUnitImperialUOM
          )
        ) {
          Alert.error(`<h4>Record already exists</h4>`, {
            position: 'top-right',
            effect: 'bouncyflip',
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else if (multipleSizeValue?.alternateUnitArr?.length <= 0) {
          alternateUnitArr.push(formData);
          formik.setFieldValue('alternateUnitArr', alternateUnitArr);
          formik.setFieldValue('alternateUnitMatricServingPax', '');
          formik.setFieldValue('alternateUnitMatricUOM', '');
          formik.setFieldValue('alternateUnitImperialServingPax', '');
          formik.setFieldValue('alternateUnitImperialUOM', '');
        } else {
          alternateUnitArr[0] = formData;
          formik.setFieldValue('alternateUnitArr', alternateUnitArr);
          formik.setFieldValue('alternateUnitMatricServingPax', '');
          formik.setFieldValue('alternateUnitMatricUOM', '');
          formik.setFieldValue('alternateUnitImperialServingPax', '');
          formik.setFieldValue('alternateUnitImperialUOM', '');
        }
      }
    }
  };

  const alternateUnitDeleteIcon = (e, indexId) => {
    let itemSize = formik.values.itemSize;
    let oneSizeValue = formik.values?.sizes?.[0];
    let multipleSizeValue = formikCustom.values;
    let alternateUnitArr =
      itemSize === 'SINGLE'
        ? oneSizeValue?.alternateUnitArr
        : multipleSizeValue?.alternateUnitArr;

    let alternateUnitArrObj = alternateUnitArr.find(
      (images, index) => index === indexId
    );
    if (itemSize === 'SINGLE') {
      if (alternateUnitArrObj === 0 || alternateUnitArrObj) {
        alternateUnitArr.splice(
          alternateUnitArr.indexOf(alternateUnitArrObj),
          1
        );
        formik.setFieldValue('sizes[0].alternateUnitMatricServingPax', '');
        formik.setFieldValue('sizes[0].alternateUnitMatricUOM', '');
        formik.setFieldValue('sizes[0].alternateUnitImperialServingPax', '');
        formik.setFieldValue('sizes[0].alternateUnitImperialUOM', '');
        formik.setFieldValue('sizes[0].alternateUnitArr', alternateUnitArr);
      }
    } else {
      if (alternateUnitArrObj === 0 || alternateUnitArrObj) {
        alternateUnitArr.splice(
          alternateUnitArr.indexOf(alternateUnitArrObj),
          1
        );
        formikCustom.setFieldValue('alternateUnitMatricServingPax', '');
        formikCustom.setFieldValue('alternateUnitMatricUOM', '');
        formikCustom.setFieldValue('alternateUnitImperialServingPax', '');
        formikCustom.setFieldValue('alternateUnitImperialUOM', '');
        formikCustom.setFieldValue('alternateUnitArr', alternateUnitArr);
      }
    }
  };

  const alternateUnitSaveAddAnother = (e) => {
    let itemSize = formik.values.itemSize;
    let oneSizeValue = formik.values?.sizes?.[0];
    let multipleSizeValue = formikCustom.values;
    let alternateUnitArr =
      itemSize === 'SINGLE'
        ? oneSizeValue?.alternateUnitArr
        : multipleSizeValue?.alternateUnitArr;

    let formData = {
      alternateUnitMatricServingPax:
        itemSize === 'SINGLE'
          ? oneSizeValue?.alternateUnitMatricServingPax
          : multipleSizeValue?.alternateUnitMatricServingPax,
      alternateUnitMatricUOM:
        itemSize === 'SINGLE'
          ? oneSizeValue?.alternateUnitMatricUOM
          : multipleSizeValue?.alternateUnitMatricUOM,
      alternateUnitImperialServingPax:
        itemSize === 'SINGLE'
          ? oneSizeValue?.alternateUnitImperialServingPax
          : multipleSizeValue?.alternateUnitImperialServingPax,
      alternateUnitImperialUOM:
        itemSize === 'SINGLE'
          ? oneSizeValue?.alternateUnitImperialUOM
          : multipleSizeValue?.alternateUnitImperialUOM,
    };
    if (itemSize === 'SINGLE') {
      if (
        oneSizeValue?.alternateUnitMatricServingPax === '' ||
        oneSizeValue?.alternateUnitMatricUOM == '' ||
        oneSizeValue?.alternateUnitImperialServingPax === '' ||
        oneSizeValue?.alternateUnitImperialUOM == ''
      ) {
        Alert.error(`<h4>Please fill all the field</h4>`, {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        if (
          alternateUnitArr.find(
            (data, index) =>
              data.alternateUnitMatricServingPax ===
                oneSizeValue?.alternateUnitMatricServingPax &&
              data.alternateUnitMatricUOM ===
                oneSizeValue?.alternateUnitMatricUOM &&
              data.alternateUnitImperialServingPax ===
                oneSizeValue?.alternateUnitImperialServingPax &&
              data.alternateUnitImperialUOM ===
                oneSizeValue?.alternateUnitImperialUOM
          )
        ) {
          Alert.error(`<h4>Record already exists</h4>`, {
            position: 'top-right',
            effect: 'bouncyflip',
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else {
          alternateUnitArr.push(formData);
          formik.setFieldValue('sizes[0].alternateUnitArr', alternateUnitArr);
          formik.setFieldValue('sizes[0].alternateUnitMatricServingPax', '');
          formik.setFieldValue('sizes[0].alternateUnitMatricUOM', '');
          formik.setFieldValue('sizes[0].alternateUnitImperialServingPax', '');
          formik.setFieldValue('sizes[0].alternateUnitImperialUOM', '');
        }
      }
    } else {
      if (
        multipleSizeValue?.alternateUnitMatricServingPax === '' ||
        multipleSizeValue?.alternateUnitMatricUOM == '' ||
        multipleSizeValue?.alternateUnitImperialServingPax === '' ||
        multipleSizeValue?.alternateUnitImperialUOM == ''
      ) {
        Alert.error(`<h4>Please fill all the field</h4>`, {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        if (
          alternateUnitArr.find(
            (data, index) =>
              data.alternateUnitMatricServingPax ===
                multipleSizeValue?.alternateUnitMatricServingPax &&
              data.alternateUnitMatricUOM ===
                multipleSizeValue?.alternateUnitMatricUOM &&
              data.alternateUnitImperialServingPax ===
                multipleSizeValue?.alternateUnitImperialServingPax &&
              data.alternateUnitImperialUOM ===
                multipleSizeValue?.alternateUnitImperialUOM
          )
        ) {
          Alert.error(`<h4>Record already exists</h4>`, {
            position: 'top-right',
            effect: 'bouncyflip',
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else {
          alternateUnitArr.push(formData);
          formikCustom.setFieldValue('alternateUnitArr', alternateUnitArr);
          formikCustom.setFieldValue('alternateUnitMatricServingPax', '');
          formikCustom.setFieldValue('alternateUnitMatricUOM', '');
          formikCustom.setFieldValue('alternateUnitImperialServingPax', '');
          formikCustom.setFieldValue('alternateUnitImperialUOM', '');
        }
      }
    }
  };

  return (
    <React.Fragment>
      {/* {console.log(formik.errors)} */}
      <Form className="mobile-pb-70">
        <div className="mb-4">
          <TopTextReusableComponent
            headingText="New Item"
            headingParagraph="Manage your food items"
          />
        </div>
        <div className="bg-gray px-3 py-2">
          <Row>
            <Col md={6}>
              <div className="d-flex align-items-center">
                <div className="f12-700 pr-3" style={{ width: 140 }}>
                  Ext Item ID :
                </div>
                <FormControl className={'w-100 bg-white'} variant="outlined">
                  <OutlinedInput
                    disabled
                    value={
                      props.menuCategoryItems && props.menuCategoryItems.ext_id
                    }
                  />
                </FormControl>
              </div>
            </Col>
          </Row>
        </div>
        <div
          className="displayItemsName f11-400 enRadius5 my-4"
          style={{ height: 50 }}
        >
          {props.menuCategoryItems && props.menuCategoryItems.name}
        </div>
        <div className="f14-700 mb-3">
          Is this Item Available in One Size or Multiple Sizes?
          <p className="f10-400 opacity5 w-75 pr-md-5">
            Please select customizable option if your item is customizable. you
            will need to set up customization attributes in further steps
          </p>
        </div>
        <div className="checkbox-bank-account justify-content-start mb-1">
          <label className="enRadioWithText small mr-3">
            <span className="f12-500">One Size</span>
            <input
              type="radio"
              name="itemSize"
              value="SINGLE"
              onChange={(e) => {
                formik.resetForm();
                formikCustom.resetForm();
                formik.handleChange(e);
                onResetPreviousData('SINGLE');
              }}
              checked={formik.values.itemSize === 'SINGLE'}
            />
            <span className="checkmark"></span>
          </label>
          <label className="enRadioWithText small mr-3">
            <span className="f12-500">Multiple Size</span>
            <input
              type="radio"
              name="itemSize"
              value="MULTIPLE"
              onChange={(e) => {
                formik.resetForm();
                formikCustom.resetForm();
                formik.handleChange(e);
                onResetPreviousData('MULTIPLE');
              }}
              checked={formik.values.itemSize === 'MULTIPLE'}
            />
            <span className="checkmark"></span>
          </label>
          <label className="enRadioWithText small mr-3">
            <span className="f12-500">Customizable</span>
            <input
              type="radio"
              name="itemSize"
              value="CUSTOM"
              onChange={(e) => {
                formik.resetForm();
                formikCustom.resetForm();
                formik.handleChange(e);
                onResetPreviousData('CUSTOM');
              }}
              checked={formik.values.itemSize === 'CUSTOM'}
            />
            <span className="checkmark"></span>
          </label>
        </div>
        {formik.errors.itemSize && formik.touched.itemSize ? (
          <div className="pho_14_regular text-danger mb-3">
            {formik.errors.itemSize}
          </div>
        ) : (
          <div className="mb-3"></div>
        )}

        <div className="f14-700 mb-3">Serving Details</div>

        {formik.values.itemSize === 'SINGLE' ? (
          <Row>
            <Col md={3} xs={12} id="alternateTestLable">
              <NewInputText
                labelText="Item Price"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                inputType="number"
                extraClass={`mb-1 ${
                  formik.errors &&
                  formik.errors.sizes &&
                  formik.errors.sizes[0] &&
                  formik.errors.sizes[0].price &&
                  formik.touched &&
                  formik.touched.sizes &&
                  formik.touched.sizes[0] &&
                  formik.touched.sizes[0].price
                    ? 'enError'
                    : ''
                }`}
                name="sizes[0].price"
                onChange={formik.handleChange}
                value={
                  formik.values &&
                  formik.values.sizes &&
                  formik.values.sizes[0].price
                }
                onFocusOut={formik.handleBlur}
              />
              {formik.errors.price &&
              formik.touched &&
              formik.touched.sizes &&
              formik.touched.sizes[0] &&
              formik.touched.sizes[0].price ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.price}
                </div>
              ) : null}
            </Col>
            {/* <Col
              md={8}
              xs={12}
              className=" pr-1  input-number-field-with-up-down-arrows"
            >
              <Row className="mobile-f8-400 m-0">
                <Col xs={12} md={6} className="menu-setup-number p-0 pr-1">
                  <NewInputText
                    labelText="Serving Size"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputType="number"
                    extraClass={`mb-1 ${
                      formik.errors &&
                      formik.errors.sizes &&
                      formik.errors.sizes[0] &&
                      formik.errors.sizes[0].size &&
                      formik.touched &&
                      formik.touched.sizes &&
                      formik.touched.sizes[0] &&
                      formik.touched.sizes[0].size
                        ? "enError"
                        : ""
                    }`}
                    name="sizes[0].size"
                    onChange={(e) => {
                      if (e.target.value >= 0) {
                        formik.handleChange(e);
                      }
                    }}
                    value={
                      formik.values &&
                      formik.values.sizes &&
                      formik.values.sizes[0].size
                        ? formik.values.sizes[0].size
                        : 0
                    }
                    onFocusOut={formik.handleBlur}
                  />
                  {formik.errors.size &&
                  formik.touched &&
                  formik.touched.sizes &&
                  formik.touched.sizes[0] &&
                  formik.touched.sizes[0].size ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.size}
                    </div>
                  ) : null}
                </Col>
                <Col xs={12} md={6} className="p-0 pr-1">
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="outlined-UoM">UoM</InputLabel>
                    <Select
                      value={state.UoM}
                      onChange={selecthandleChange}
                      label="UoM"
                      inputProps={{
                        name: "UoM",
                        id: "outlined-UoM",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {/* <MenuItem value={"Plate"}>Plate</MenuItem>
                      <MenuItem value={"Bowl"}>Bowl</MenuItem>
                      <MenuItem value={"KG"}>KG</MenuItem> *
                      {props.uom_info.map((item, index) => (
                        <MenuItem key={index} value={item.title}>
                          {item.title} {item.description}
                        </MenuItem>
                      ))}
                    </Select>
                    {formik.errors.uom &&
                    formik.touched &&
                    formik.touched.sizes &&
                    formik.touched.sizes[0] &&
                    formik.touched.sizes[0].uom ? (
                      <div className="pho_14_regular text-danger">
                        {formik.errors.uom}
                      </div>
                    ) : null}
                  </FormControl>
                </Col>
              </Row>
            </Col> */}
            <Col
              xs={12}
              md={3}
              id="alternateTestLable"
              className="input-number-field-with-up-down-arrows"
            >
              <NewInputText
                labelText="Serving PAX "
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                min={0}
                inputType="number"
                extraClass={`mb-1 ${
                  formik.errors &&
                  formik.errors.sizes &&
                  formik.errors.sizes[0] &&
                  formik.errors.sizes[0].pax &&
                  formik.touched &&
                  formik.touched.sizes &&
                  formik.touched.sizes[0] &&
                  formik.touched.sizes[0].pax
                    ? 'enError'
                    : ''
                }`}
                name="sizes[0].pax"
                onChange={(e) => {
                  if (e.target.value >= 0) {
                    formik.handleChange(e);
                  }
                }}
                value={
                  formik.values &&
                  formik.values.sizes &&
                  formik.values.sizes[0].pax
                    ? formik.values.sizes[0].pax
                    : 0
                }
                onFocusOut={formik.handleBlur}
              />
              {formik.errors.size &&
              formik.touched &&
              formik.touched.sizes &&
              formik.touched.sizes[0] &&
              formik.touched.sizes[0].pax ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.pax}
                </div>
              ) : null}
            </Col>
            <Col id="alternateTestLable" md={3} xs={12}>
              <NewInputText
                labelText="Calories"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                extraClass={`mb-1 ${
                  formik.errors &&
                  formik.errors.sizes &&
                  formik.errors.sizes[0] &&
                  formik.errors.sizes[0].calories &&
                  formik.touched &&
                  formik.touched.sizes &&
                  formik.touched.sizes[0] &&
                  formik.touched.sizes[0].calories
                    ? 'enError'
                    : ''
                }`}
                name="sizes[0].calories"
                onChange={(e) => {
                  if (e.target.value >= 0) {
                    formik.handleChange(e);
                  }
                }}
                value={
                  formik.values &&
                  formik.values.sizes &&
                  formik.values.sizes[0].calories
                }
                onFocusOut={formik.handleBlur}
              />
              {formik.errors.calories &&
              formik.touched &&
              formik.touched.sizes &&
              formik.touched.sizes[0] &&
              formik.touched.sizes[0].calories ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.calories}
                </div>
              ) : null}
            </Col>
            {props.productClassification === 'Alcoholic Beverage' ||
            props.productClassification === 'Packed Alcoholic Beverage' ? (
              <Col
                xs={12}
                md={3}
                id="alternateTestLable"
                className="input-number-field-with-up-down-arrows position-relative"
              >
                <div className="d-flex align-items-center">
                  <NewInputText
                    labelText={'Alcohol content'}
                    onKeyPress={(event) => {
                      if (!/[0-9]*\.?[0-9]*/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputType="text"
                    extraClass={`mb-1 ${
                      formik.errors &&
                      formik.errors.sizes &&
                      formik.errors.sizes[0] &&
                      formik.errors.sizes[0].alcoholContent &&
                      formik.touched &&
                      formik.touched.sizes &&
                      formik.touched.sizes[0] &&
                      formik.touched.sizes[0].alcoholContent
                        ? 'enError'
                        : ''
                    }`}
                    name="sizes[0].alcoholContent"
                    onChange={(e) => {
                      if (e.target.value <= 100) {
                        formik.handleChange(e);
                      }
                    }}
                    maxLength={'5'}
                    value={
                      formik.values &&
                      formik.values.sizes &&
                      formik.values.sizes[0].alcoholContent
                        ? formik.values.sizes[0].alcoholContent
                        : ''
                    }
                    onFocusOut={formik.handleBlur}
                  />
                  <span
                    className="position-absolute"
                    style={{ right: 25, top: 8 }}
                  >
                    %
                  </span>
                </div>
                {formik.errors.size &&
                formik.touched &&
                formik.touched.sizes &&
                formik.touched.sizes[0] &&
                formik.touched.sizes[0].alcoholContent ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.alcoholContent}
                  </div>
                ) : null}
              </Col>
            ) : null}
            <Col sm={12} md={12} lg={12} xl={12}>
              <Row>
                <Col sm={12} md={12} lg={12}>
                  <h3 className="f14-700 my-3">Main Unit of Measurement</h3>
                </Col>
                <Col>
                  <Row>
                    <Col id="alternateTestLable">
                      <NewInputText
                        labelText="Serving PAX "
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        min={0}
                        inputType="number"
                        extraClass={`mb-1 ${
                          formik.errors &&
                          formik.errors.sizes &&
                          formik.errors.sizes[0] &&
                          formik.errors.sizes[0].mainUnitMatricServingPax &&
                          formik.touched &&
                          formik.touched.sizes &&
                          formik.touched.sizes[0] &&
                          formik.touched.sizes[0].mainUnitMatricServingPax
                            ? 'enError'
                            : ''
                        }`}
                        name="sizes[0].mainUnitMatricServingPax"
                        onChange={(e) => {
                          if (e.target.value >= 0) {
                            formik.handleChange(e);
                          }
                        }}
                        value={
                          formik.values &&
                          formik.values.sizes &&
                          formik.values.sizes[0].mainUnitMatricServingPax
                            ? formik.values.sizes[0].mainUnitMatricServingPax
                            : 0
                        }
                        onFocusOut={formik.handleBlur}
                      />
                      {formik.errors.size &&
                      formik.touched &&
                      formik.touched.sizes &&
                      formik.touched.sizes[0] &&
                      formik.touched.sizes[0].mainUnitMatricServingPax ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.mainUnitMatricServingPax}
                        </div>
                      ) : null}
                    </Col>
                    <Col
                      id="alternateTestLable"
                      className="position-relative d-flex align-items-center"
                    >
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <InputLabel htmlFor="outlined-UoM">UoM</InputLabel>
                        <Select
                          value={
                            formik.values &&
                            formik.values.sizes &&
                            formik.values.sizes[0].mainUnitMatricUOM
                              ? formik.values.sizes[0].mainUnitMatricUOM
                              : 0
                          }
                          onChange={formik.handleChange}
                          label="UoM"
                          inputProps={{
                            name: 'sizes[0].mainUnitMatricUOM',
                            id: 'outlined-UoM',
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <MenuItem value={'Select UOM'} disabled selected>
                            Select UOM
                          </MenuItem>
                          {props?.uomManagement?.map((item, index) => (
                            <MenuItem
                              key={index}
                              value={item.short_code + ' ' + item.unit_name}
                              onClick={(e) =>
                                onChangeuUomMatric(e, item, 'ONESIZE')
                              }
                            >
                              {item.short_code} (
                              {item.unit_name.substring(0, 5)})
                            </MenuItem>
                          ))}
                          {/* {props?.uomManagement.map((item, index) => (
                            <MenuItem
                              key={index}
                              value={item.title + " " + item.description}
                            >
                              {item.title} {item.description}
                            </MenuItem>
                          ))} */}
                        </Select>
                        {formik.errors.mainUnitMatricUOM &&
                        formik.touched &&
                        formik.touched.sizes &&
                        formik.touched.sizes[0] &&
                        formik.touched.sizes[0].mainUnitMatricUOM ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.mainUnitMatricUOM}
                          </div>
                        ) : null}
                      </FormControl>
                      <div
                        className="border-right position-absolute"
                        style={{ height: '75%', right: '0', top: '0' }}
                      ></div>
                    </Col>
                    <Col
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="text-center"
                    >
                      <img
                        src={require('../../../../../../../../assets/images/Icon/openBracket.png')}
                        alt="Metric System"
                        title="Metric System"
                        className="img-fluid rotted-images-cs"
                      />
                      <h3 className="f10-400 my-2">(Metric System)</h3>
                    </Col>
                  </Row>
                </Col>
                <Col sm={12} md={6} lg={6} xl={6}>
                  <Row>
                    <Col id="alternateTestLable">
                      <NewInputText
                        labelText="Serving PAX "
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        min={0}
                        inputType="number"
                        extraClass={`mb-1 ${
                          formik.errors &&
                          formik.errors.sizes &&
                          formik.errors.sizes[0] &&
                          formik.errors.sizes[0].mainUnitImperialServingPax &&
                          formik.touched &&
                          formik.touched.sizes &&
                          formik.touched.sizes[0] &&
                          formik.touched.sizes[0].mainUnitImperialServingPax
                            ? 'enError'
                            : ''
                        }`}
                        name="sizes[0].mainUnitImperialServingPax"
                        onChange={(e) => {
                          if (e.target.value >= 0) {
                            formik.handleChange(e);
                          }
                        }}
                        value={
                          formik.values &&
                          formik.values.sizes &&
                          formik.values.sizes[0].mainUnitImperialServingPax
                            ? formik.values.sizes[0].mainUnitImperialServingPax
                            : 0
                        }
                        onFocusOut={formik.handleBlur}
                        disabled
                      />
                      {formik.errors.size &&
                      formik.touched &&
                      formik.touched.sizes &&
                      formik.touched.sizes[0] &&
                      formik.touched.sizes[0].mainUnitImperialServingPax ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.mainUnitImperialServingPax}
                        </div>
                      ) : null}
                    </Col>
                    <Col id="alternateTestLable" className="position-relative">
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <InputLabel htmlFor="outlined-UoM">UoM</InputLabel>
                        <Select
                          value={
                            formik.values &&
                            formik.values.sizes &&
                            formik.values.sizes[0].mainUnitImperialUOM
                              ? formik.values.sizes[0].mainUnitImperialUOM
                              : 0
                          }
                          onChange={formik.handleChange}
                          label="UoM"
                          inputProps={{
                            name: 'sizes[0].mainUnitImperialUOM',
                            id: 'outlined-UoM',
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          <MenuItem value={'Select UOM'} disabled selected>
                            Select UOM
                          </MenuItem>
                          {props?.conversationData?.map(
                            (item, index) => (
                              // item?.short_code + " " + item?.unit_name !==
                              // formikCustom.values?.mainUnitMatricUOM ? (
                              <MenuItem
                                key={index}
                                value={item?.conversion_to_short_code}
                                onClick={(e) =>
                                  onChangeuUomImperial(e, item, 'ONESIZE')
                                }
                              >
                                {item.conversion_to_short_code}
                              </MenuItem>
                            )
                            // ) : null
                          )}
                          {/* {props?.uom_info.map((item, index) => (
                            <MenuItem
                              key={index}
                              value={item.title + " " + item.description}
                            >
                              {item.title} {item.description}
                            </MenuItem>
                          ))} */}
                        </Select>
                        {formik.errors.mainUnitImperialUOM &&
                        formik.touched &&
                        formik.touched.sizes &&
                        formik.touched.sizes[0] &&
                        formik.touched.sizes[0].mainUnitImperialUOM ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.mainUnitImperialUOM}
                          </div>
                        ) : null}
                      </FormControl>
                    </Col>
                    <Col
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="text-center"
                    >
                      <img
                        src={require('../../../../../../../../assets/images/Icon/openBracket.png')}
                        alt="Imperial System"
                        title="Imperial System"
                        className="img-fluid rotted-images-cs"
                      />
                      <h3 className="f10-400 my-2">(Imperial System)</h3>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={12} lg={12}>
                  <h3 className="f14-700 mt-4 mb-3">
                    Alternate Unit of Measurement
                  </h3>{' '}
                </Col>
                <Col>
                  <Row>
                    <Col id="alternateTestLable">
                      <NewInputText
                        labelText="Alternate Serving Size"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        min={0}
                        inputType="number"
                        extraClass={`mb-1 ${
                          formik.errors &&
                          formik.errors.sizes &&
                          formik.errors.sizes[0] &&
                          formik.errors.sizes[0]
                            .alternateUnitMatricServingPax &&
                          formik.touched &&
                          formik.touched.sizes &&
                          formik.touched.sizes[0] &&
                          formik.touched.sizes[0].alternateUnitMatricServingPax
                            ? 'enError'
                            : ''
                        }`}
                        name="sizes[0].alternateUnitMatricServingPax"
                        onChange={(e) => {
                          if (e.target.value >= 0) {
                            formik.handleChange(e);
                          }
                        }}
                        value={
                          formik.values &&
                          formik.values.sizes &&
                          formik.values.sizes[0].alternateUnitMatricServingPax
                            ? formik.values.sizes[0]
                                .alternateUnitMatricServingPax
                            : 0
                        }
                        onFocusOut={formik.handleBlur}
                      />
                      {formik.errors?.alternateUnitMatricServingPax &&
                      formik.touched &&
                      formik.touched.sizes &&
                      formik.touched.sizes[0] &&
                      formik.touched.sizes[0].alternateUnitMatricServingPax ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.alternateUnitMatricServingPax}
                        </div>
                      ) : null}
                    </Col>
                    <Col
                      id="alternateTestLable"
                      className="position-relative d-flex align-items-center"
                    >
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <InputLabel htmlFor="outlined-UoM">AUoM</InputLabel>
                        <Select
                          value={
                            formik.values &&
                            formik.values.sizes &&
                            formik.values.sizes[0].alternateUnitMatricUOM
                              ? formik.values.sizes[0].alternateUnitMatricUOM
                              : ''
                          }
                          onChange={formik.handleChange}
                          label="AUoM"
                          inputProps={{
                            name: 'sizes[0].alternateUnitMatricUOM',
                            id: 'outlined-UoM',
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {/* {props.uom_info.map((item, index) => (
                            <MenuItem
                              key={index}
                              value={item.title + " " + item.description}
                            >
                              {item.title} {item.description}
                            </MenuItem>
                          ))} */}
                          <MenuItem value={'Select AUOM'} disabled selected>
                            Select AUOM
                          </MenuItem>
                          {props.uomManagement.map((item, index) => (
                            <MenuItem
                              key={index}
                              value={item.short_code}
                              onClick={(e) =>
                                onChangeuAuomMatric(e, item, 'ONESIZE')
                              }
                            >
                              {item.short_code} (
                              {item.unit_name.substring(0, 5)})
                            </MenuItem>
                          ))}
                        </Select>
                        {formik.errors?.alternateUnitMatricUOM &&
                        formik.touched &&
                        formik.touched.sizes &&
                        formik.touched.sizes[0] &&
                        formik.touched.sizes[0].alternateUnitMatricUOM ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.alternateUnitMatricUOM}
                          </div>
                        ) : null}
                      </FormControl>
                      <div
                        className="border-right position-absolute"
                        style={{ height: '75%', right: '0', top: '0' }}
                      ></div>
                    </Col>
                    <Col
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="text-center"
                    >
                      <img
                        src={require('../../../../../../../../assets/images/Icon/openBracket.png')}
                        alt="Metric System"
                        title="Metric System"
                        className="img-fluid rotted-images-cs"
                      />
                      <h3 className="f10-400 my-2">(Metric System)</h3>
                    </Col>
                  </Row>
                </Col>
                <Col sm={12} md={6} lg={6} xl={6}>
                  <Row>
                    <Col id="alternateTestLable">
                      <NewInputText
                        labelText="Alternate Serving Size"
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        min={0}
                        inputType="number"
                        extraClass={`mb-1 ${
                          formik.errors &&
                          formik.errors.sizes &&
                          formik.errors.sizes[0] &&
                          formik.errors.sizes[0]
                            .alternateUnitImperialServingPax &&
                          formik.touched &&
                          formik.touched.sizes &&
                          formik.touched.sizes[0] &&
                          formik.touched.sizes[0]
                            .alternateUnitImperialServingPax
                            ? 'enError'
                            : ''
                        }`}
                        name="sizes[0].alternateUnitImperialServingPax"
                        onChange={(e) => {
                          if (e.target.value >= 0) {
                            formik.handleChange(e);
                          }
                        }}
                        value={
                          formik.values &&
                          formik.values.sizes &&
                          formik.values.sizes[0].alternateUnitImperialServingPax
                            ? formik.values.sizes[0]
                                .alternateUnitImperialServingPax
                            : 0
                        }
                        onFocusOut={formik.handleBlur}
                      />
                      {formik.errors?.alternateUnitImperialServingPax &&
                      formik.touched &&
                      formik.touched.sizes &&
                      formik.touched.sizes[0] &&
                      formik.touched.sizes[0]
                        .alternateUnitImperialServingPax ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.alternateUnitImperialServingPax}
                        </div>
                      ) : null}
                    </Col>

                    <Col id="alternateTestLable" className="position-relative">
                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                      >
                        <InputLabel htmlFor="outlined-UoM">AUoM</InputLabel>
                        <Select
                          value={
                            formik.values &&
                            formik.values.sizes &&
                            formik.values.sizes[0].alternateUnitImperialUOM
                              ? formik.values.sizes[0].alternateUnitImperialUOM
                              : ''
                          }
                          onChange={formik.handleChange}
                          label="AUoM"
                          inputProps={{
                            name: 'sizes[0].alternateUnitImperialUOM',
                            id: 'outlined-UoM',
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {/* {props.uom_info.map((item, index) => (
                            <MenuItem
                              key={index}
                              value={item.title + " " + item.description}
                            >
                              {item.title} {item.description}
                            </MenuItem>
                          ))} */}
                          <MenuItem value={'Select AUOM'} disabled selected>
                            Select AUOM
                          </MenuItem>
                          {props?.conversationDataTwo?.map(
                            (item, index) => (
                              // item?.short_code + " " + item?.unit_name !==
                              // formikCustom.values?.mainUnitMatricUOM ? (
                              <MenuItem
                                key={index}
                                value={item?.conversion_to_short_code}
                                onClick={(e) =>
                                  onChangeuAomImperial(e, item, 'ONESIZE')
                                }
                              >
                                {item.conversion_to_short_code}
                              </MenuItem>
                            )
                            // ) : null
                          )}
                        </Select>
                        {formik.errors?.alternateUnitImperialUOM &&
                        formik.touched &&
                        formik.touched.sizes &&
                        formik.touched.sizes[0] &&
                        formik.touched.sizes[0].alternateUnitImperialUOM ? (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.alternateUnitImperialUOM}
                          </div>
                        ) : null}
                      </FormControl>
                    </Col>
                    <Col
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="text-center"
                    >
                      <img
                        src={require('../../../../../../../../assets/images/Icon/openBracket.png')}
                        alt="Imperial System"
                        title="Imperial System"
                        className="img-fluid rotted-images-cs"
                      />
                      <h3 className="f10-400 my-2">(Imperial System)</h3>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="py-4">
                <Col xs={6} md={4}>
                  <AddButtonIconComponent
                    buttonText="Save"
                    fontIcon="fa fa-plus"
                    colorCss="blue"
                    type="button"
                    onClick={(e) => alternateUnitSave(e)}
                  />
                </Col>
                <Col xs={6} md={5}>
                  <AddButtonIconComponent
                    buttonText="Save and Add Another"
                    fontIcon="fa fa-plus"
                    colorCss="blue"
                    type="button"
                    onClick={(e) => alternateUnitSaveAddAnother(e)}
                  />
                </Col>
              </Row>
              <Row>
                {formik.values?.sizes?.[0]?.alternateUnitArr?.length >= 1 ? (
                  <div className="table-responsive">
                    <table className="table table-hover f10-500">
                      <thead>
                        <tr>
                          <th scope="col">Matric Serving Size</th>
                          <th scope="col">Matric UOM</th>
                          <th scope="col">Imperial Serving Size</th>
                          <th scope="col">Imperial UOM</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formik.values?.sizes?.[0]?.alternateUnitArr.map(
                          (item, index) => {
                            return (
                              <tr key={index}>
                                <td
                                  className="py-0"
                                  style={{ verticalAlign: 'middle' }}
                                >
                                  {item?.alternateUnitMatricServingPax}
                                </td>
                                <td
                                  className="py-0"
                                  style={{ verticalAlign: 'middle' }}
                                >
                                  {item?.alternateUnitMatricUOM}
                                </td>
                                <td
                                  className="py-0"
                                  style={{ verticalAlign: 'middle' }}
                                >
                                  {item?.alternateUnitImperialServingPax}
                                </td>
                                <td
                                  className="py-0"
                                  style={{ verticalAlign: 'middle' }}
                                >
                                  {item?.alternateUnitImperialUOM}
                                </td>
                                <td
                                  className="py-0"
                                  style={{ verticalAlign: 'middle' }}
                                >
                                  <IconButton>
                                    <Image
                                      src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                      alt="delete image"
                                      title="delete item"
                                      className="w-20px p-0"
                                      onClick={(e) =>
                                        alternateUnitDeleteIcon(e, index)
                                      }
                                    />
                                  </IconButton>
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    </table>
                  </div>
                ) : null}
              </Row>
            </Col>
          </Row>
        ) : (
          <> </>
        )}
        {/* <div className="f14-400 mb-3">
          Move to the next step - you will need to set up customization
          attributes in further steps
        </div> */}
        {/**********************/}
        {formik.values.itemSize === 'multiplee' ? (
          <Row>
            <Col md={10} xs={10} className="pb-3">
              <NewInputText
                labelText="Add description"
                extraClass="mb-0 w-100"
              />
            </Col>
            <Col md={2} xs={10} className="pt-2">
              {/* <AddButtonIconComponent
              buttonText="Delete"
              fontIcon="fa fa-trash-o"
              colorCss="delete"
            /> */}
            </Col>
            <Col md={3} align="right" className="pb-3">
              <NewInputText labelText="Item Price" extraClass="mb-0" />
            </Col>
            <Col md={9}>
              <Row className="mobile-f8-400">
                <Col xs={4} className="pb-3">
                  <NewInputText
                    labelText="Serving PAX"
                    inputType="number"
                    extraClass="mb-0"
                    inputProps={{ min: 0 }}
                    min="0"
                    onChange={(e) => {
                      if (e.target.value >= 0) {
                        formik.handleChange(e);
                      }
                    }}
                  />
                </Col>
                <Col xs={4} className="pb-3">
                  <NewInputText
                    labelText="Serving Size"
                    inputType="number"
                    extraClass="mb-0"
                  />
                </Col>
                <Col xs={4} className="pb-3">
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel htmlFor="outlined-UoM">UoM</InputLabel>
                    <Select
                      value={state.UoM}
                      onChange={selecthandleChange}
                      label="UoM"
                      inputProps={{
                        name: 'UoM',
                        id: 'outlined-UoM',
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value={'Plate'}>Plate</option>
                    </Select>
                  </FormControl>
                </Col>
              </Row>
            </Col>
          </Row>
        ) : (
          <> </>
        )}

        <>
          {formik.values.itemSize === 'MULTIPLE' ||
          formik.values.itemSize === 'CUSTOM' ? (
            <>
              <Row>
                <Col md={12} xs={12} id="alternateTestLable">
                  <NewInputText
                    labelText="Add description"
                    extraClass={`mb-3 w-100 ${
                      formikCustom.errors.description &&
                      formikCustom.touched.description
                        ? 'enError'
                        : ''
                    }`}
                    name="description"
                    //onChange={formikCustom.handleChange}
                    onChange={(e) => titleCase(e.target.value, 'description')}
                    value={formikCustom.values.description}
                    onFocusOut={formikCustom.handleBlur}
                  />
                  {formikCustom.errors.description &&
                  formikCustom.touched.description ? (
                    <div className="pho_14_regular text-danger">
                      {formikCustom.errors.description}
                    </div>
                  ) : null}
                </Col>
                <Col md={3} xs={12} id="alternateTestLable">
                  <NewInputText
                    inputType="number"
                    labelText="Item Price"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    extraClass={`mb-1 ${
                      formikCustom.errors.price && formikCustom.touched.price
                        ? 'enError'
                        : ''
                    }`}
                    name="price"
                    onChange={(e) => {
                      if (e.target.value >= 0) {
                        formikCustom.handleChange(e);
                      }
                    }}
                    // onChange={formikCustom.handleChange}
                    value={formikCustom.values.price}
                    onFocusOut={formikCustom.handleBlur}
                  />
                  {formikCustom.errors.price && formikCustom.touched.price ? (
                    <div className="pho_14_regular text-danger">
                      {formikCustom.errors.price}
                    </div>
                  ) : null}
                </Col>
                <Col xs={12} md={3} id="alternateTestLable">
                  <NewInputText
                    labelText="Serving PAX"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    inputType="number"
                    extraClass={`mb-1 ${
                      formikCustom.errors.pax && formikCustom.touched.pax
                        ? 'enError'
                        : ''
                    }`}
                    name="pax"
                    onChange={(e) => {
                      if (e.target.value >= 0) {
                        formikCustom.handleChange(e);
                      }
                    }}
                    // onChange={formikCustom.handleChange}
                    value={formikCustom.values.pax}
                    onFocusOut={formikCustom.handleBlur}
                  />
                  {formikCustom.errors.pax && formikCustom.touched.pax ? (
                    <div className="pho_14_regular text-danger">
                      {formikCustom.errors.pax}
                    </div>
                  ) : null}
                </Col>
                <Col md={3} xs={12} id="alternateTestLable">
                  <NewInputText
                    labelText="Calories"
                    inputType="number"
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    extraClass={`mb-1 ${
                      formikCustom.errors.calories &&
                      formikCustom.touched.calories
                        ? 'enError'
                        : ''
                    }`}
                    name="calories"
                    onChange={(e) => {
                      if (e.target.value >= 0) {
                        formikCustom.handleChange(e);
                      }
                    }}
                    value={formikCustom.values.calories}
                    onFocusOut={formikCustom.handleBlur}
                  />
                  {formikCustom.errors.calories &&
                  formikCustom.touched.calories ? (
                    <div className="pho_14_regular text-danger">
                      {formikCustom.errors.calories}
                    </div>
                  ) : null}
                </Col>
                {props.productClassification === 'Alcoholic Beverage' ||
                props.productClassification === 'Packed Alcoholic Beverage' ? (
                  <Col
                    xs={12}
                    md={3}
                    id="alternateTestLable"
                    className="input-number-field-with-up-down-arrows"
                  >
                    <div className="d-flex align-items-center">
                      <NewInputText
                        labelText="Alcohol content"
                        inputType="text"
                        onKeyPress={(event) => {
                          if (!/[0-9]*\.?[0-9]*/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        extraClass={`mb-1 ${
                          formikCustom.errors.alcoholContent &&
                          formikCustom.touched.alcoholContent
                            ? 'enError'
                            : ''
                        }`}
                        name="alcoholContent"
                        onChange={(e) => {
                          if (e.target.value <= 100) {
                            formikCustom.handleChange(e);
                          }
                        }}
                        value={formikCustom.values.alcoholContent}
                        onFocusOut={formikCustom.handleBlur}
                      />
                      <span
                        className="position-absolute"
                        style={{ right: 25, top: 8 }}
                      >
                        %
                      </span>
                    </div>
                    {formikCustom.errors.alcoholContent &&
                    formikCustom.touched.alcoholContent ? (
                      <div className="pho_14_regular text-danger">
                        {formikCustom.errors.alcoholContent}
                      </div>
                    ) : null}
                  </Col>
                ) : null}
                <Col sm={12} md={12} lg={12} xl={12}>
                  <Row>
                    <Col sm={12} md={12} lg={12}>
                      <h3 className="f14-700 my-3">Main Unit of Measurement</h3>
                    </Col>
                    <Col>
                      <Row>
                        <Col id="alternateTestLable">
                          <NewInputText
                            labelText="Serving PAX "
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            min={0}
                            inputType="number"
                            extraClass={`mb-1 ${
                              formikCustom.errors?.mainUnitMatricServingPax &&
                              formikCustom.touched?.mainUnitMatricServingPax
                                ? 'enError'
                                : ''
                            }`}
                            name="mainUnitMatricServingPax"
                            onChange={(e) => {
                              if (e.target.value >= 0) {
                                formikCustom.handleChange(e);
                              }
                            }}
                            value={
                              formikCustom.values?.mainUnitMatricServingPax
                                ? formikCustom.values?.mainUnitMatricServingPax
                                : 0
                            }
                            onFocusOut={formikCustom.handleBlur}
                          />
                          {formikCustom.errors.mainUnitMatricServingPax &&
                          formikCustom.touched?.mainUnitMatricServingPax ? (
                            <div className="pho_14_regular text-danger">
                              {formikCustom.errors?.mainUnitMatricServingPax}
                            </div>
                          ) : null}
                        </Col>
                        <Col
                          id="alternateTestLable"
                          className="position-relative d-flex align-items-center"
                        >
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                          >
                            <InputLabel htmlFor="outlined-UoM">UoM</InputLabel>
                            <Select
                              value={
                                formikCustom.values?.mainUnitMatricUOM
                                  ? formikCustom.values?.mainUnitMatricUOM
                                  : 0
                              }
                              onChange={formikCustom.handleChange}
                              // onChange={(e) => onChangeuUomMatric(e)}
                              label="UoM"
                              inputProps={{
                                name: 'mainUnitMatricUOM',
                                id: 'outlined-UoM',
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <MenuItem value={'Select UOM'} disabled selected>
                                Select UOM
                              </MenuItem>
                              {props.uomManagement.map((item, index) => (
                                <MenuItem
                                  key={index}
                                  value={item.short_code + ' ' + item.unit_name}
                                  onClick={(e) =>
                                    onChangeuUomMatric(e, item, 'UOM')
                                  }
                                >
                                  {item.short_code} (
                                  {item.unit_name.substring(0, 5)})
                                </MenuItem>
                              ))}
                            </Select>
                            {formikCustom.errors?.mainUnitMatricUOM &&
                            formikCustom.touched?.mainUnitMatricUOM ? (
                              <div className="pho_14_regular text-danger">
                                {formikCustom.errors?.mainUnitMatricUOM}
                              </div>
                            ) : null}
                          </FormControl>
                          <div
                            className="border-right position-absolute"
                            style={{ height: '75%', right: '0', top: '0' }}
                          ></div>
                        </Col>
                        <Col
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="text-center"
                        >
                          <img
                            src={require('../../../../../../../../assets/images/Icon/openBracket.png')}
                            alt="Metric System"
                            title="Metric System"
                            className="img-fluid rotted-images-cs"
                          />
                          <h3 className="f10-400 my-2">(Metric System)</h3>
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={12} md={6} lg={6} xl={6}>
                      <Row>
                        <Col id="alternateTestLable">
                          <NewInputText
                            labelText="Serving PAX "
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            min={0}
                            inputType="number"
                            extraClass={`mb-1 ${
                              formikCustom.errors?.mainUnitImperialServingPax &&
                              formikCustom.touched?.mainUnitImperialServingPax
                                ? 'enError'
                                : ''
                            }`}
                            name="mainUnitImperialServingPax"
                            onChange={(e) => {
                              if (e.target.value >= 0) {
                                formikCustom.handleChange(e);
                              }
                            }}
                            value={
                              formikCustom.values?.mainUnitImperialServingPax
                                ? formikCustom.values
                                    ?.mainUnitImperialServingPax
                                : 0
                            }
                            onFocusOut={formikCustom.handleBlur}
                            disabled
                          />
                          {formikCustom.errors.mainUnitImperialServingPax &&
                          formikCustom.touched?.mainUnitImperialServingPax ? (
                            <div className="pho_14_regular text-danger">
                              {formikCustom.errors?.mainUnitImperialServingPax}
                            </div>
                          ) : null}
                        </Col>
                        <Col
                          id="alternateTestLable"
                          className="position-relative"
                        >
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                          >
                            <InputLabel htmlFor="outlined-UoM">UoM</InputLabel>
                            <Select
                              value={
                                formikCustom.values?.mainUnitImperialUOM
                                  ? formikCustom.values?.mainUnitImperialUOM
                                  : 0
                              }
                              onChange={formikCustom.handleChange}
                              label="UoM"
                              inputProps={{
                                name: 'mainUnitImperialUOM',
                                id: 'outlined-UoM',
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <MenuItem value={'Select UOM'} disabled selected>
                                Select UOM
                              </MenuItem>
                              {props?.conversationData?.map(
                                (item, index) => (
                                  // item?.short_code + " " + item?.unit_name !==
                                  // formikCustom.values?.mainUnitMatricUOM ? (
                                  <MenuItem
                                    key={index}
                                    value={item?.conversion_to_short_code}
                                    onClick={(e) =>
                                      onChangeuUomImperial(e, item, 'UOM')
                                    }
                                  >
                                    {item.conversion_to_short_code}
                                  </MenuItem>
                                )
                                // ) : null
                              )}
                            </Select>
                            {formikCustom.errors?.mainUnitImperialUOM &&
                            formikCustom.touched?.mainUnitImperialUOM ? (
                              <div className="pho_14_regular text-danger">
                                {formikCustom.errors?.mainUnitImperialUOM}
                              </div>
                            ) : null}
                          </FormControl>
                        </Col>
                        <Col
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="text-center"
                        >
                          <img
                            src={require('../../../../../../../../assets/images/Icon/openBracket.png')}
                            alt="Imperial System"
                            title="Imperial System"
                            className="img-fluid rotted-images-cs"
                          />
                          <h3 className="f10-400 my-2">(Imperial System)</h3>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} md={12} lg={12}>
                      <h3 className="f14-700 mt-4 mb-3">
                        Alternate Unit of Measurement
                      </h3>{' '}
                    </Col>
                    <Col>
                      <Row>
                        <Col id="alternateTestLable">
                          <NewInputText
                            labelText="Alternate Serving Size"
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            min={0}
                            inputType="number"
                            extraClass={`mb-1 ${
                              formikCustom.errors
                                ?.alternateUnitMatricServingPax &&
                              formikCustom.touched
                                ?.alternateUnitMatricServingPax
                                ? 'enError'
                                : ''
                            }`}
                            name="alternateUnitMatricServingPax"
                            onChange={(e) => {
                              if (e.target.value >= 0) {
                                formikCustom.handleChange(e);
                              }
                            }}
                            value={
                              formikCustom.values?.alternateUnitMatricServingPax
                                ? formikCustom.values
                                    ?.alternateUnitMatricServingPax
                                : 0
                            }
                            onFocusOut={formikCustom.handleBlur}
                          />
                          {formikCustom.errors?.alternateUnitMatricServingPax &&
                          formikCustom.touched
                            ?.alternateUnitMatricServingPax ? (
                            <div className="pho_14_regular text-danger">
                              {
                                formikCustom.errors
                                  ?.alternateUnitMatricServingPax
                              }
                            </div>
                          ) : null}
                        </Col>
                        <Col
                          id="alternateTestLable"
                          className="position-relative d-flex align-items-center"
                        >
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                          >
                            <InputLabel htmlFor="outlined-UoM">AUoM</InputLabel>
                            <Select
                              value={
                                formikCustom.values?.alternateUnitMatricUOM
                                  ? formikCustom.values?.alternateUnitMatricUOM
                                  : ''
                              }
                              onChange={formikCustom.handleChange}
                              label="AUoM"
                              inputProps={{
                                name: 'alternateUnitMatricUOM',
                                id: 'outlined-UoM',
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <MenuItem value={'Select AUOM'} disabled selected>
                                Select AUOM
                              </MenuItem>
                              {props.uomManagement.map((item, index) => (
                                <MenuItem
                                  key={index}
                                  value={item.short_code}
                                  onClick={(e) =>
                                    onChangeuAuomMatric(e, item, 'AUOM')
                                  }
                                >
                                  {item.short_code} (
                                  {item.unit_name.substring(0, 5)})
                                </MenuItem>
                              ))}
                            </Select>
                            {formikCustom.errors?.alternateUnitMatricUOM &&
                            formikCustom.touched?.alternateUnitMatricUOM ? (
                              <div className="pho_14_regular text-danger">
                                {formikCustom.errors?.alternateUnitMatricUOM}
                              </div>
                            ) : null}
                          </FormControl>
                          <div
                            className="border-right position-absolute"
                            style={{ height: '75%', right: '0', top: '0' }}
                          ></div>
                        </Col>
                        <Col
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="text-center"
                        >
                          <img
                            src={require('../../../../../../../../assets/images/Icon/openBracket.png')}
                            alt="Metric System"
                            title="Metric System"
                            className="img-fluid rotted-images-cs"
                          />
                          <h3 className="f10-400 my-2">(Metric System)</h3>
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={12} md={6} lg={6} xl={6}>
                      <Row>
                        <Col id="alternateTestLable">
                          <NewInputText
                            labelText="Alternate Serving Size"
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            min={0}
                            inputType="number"
                            extraClass={`mb-1 ${
                              formikCustom.errors
                                ?.alternateUnitImperialServingPax &&
                              formikCustom.touched
                                ?.alternateUnitImperialServingPax
                                ? 'enError'
                                : ''
                            }`}
                            name="alternateUnitImperialServingPax"
                            onChange={(e) => {
                              if (e.target.value >= 0) {
                                formikCustom.handleChange(e);
                              }
                            }}
                            value={
                              formikCustom.values
                                ?.alternateUnitImperialServingPax
                                ? formikCustom.values
                                    ?.alternateUnitImperialServingPax
                                : 0
                            }
                            onFocusOut={formikCustom.handleBlur}
                            disabled
                          />
                          {formikCustom.errors
                            ?.alternateUnitImperialServingPax &&
                          formikCustom.touched
                            ?.alternateUnitImperialServingPax ? (
                            <div className="pho_14_regular text-danger">
                              {
                                formikCustom.errors
                                  ?.alternateUnitImperialServingPax
                              }
                            </div>
                          ) : null}
                        </Col>

                        <Col
                          id="alternateTestLable"
                          className="position-relative"
                        >
                          <FormControl
                            variant="outlined"
                            className={classes.formControl}
                          >
                            <InputLabel htmlFor="outlined-UoM">AUoM</InputLabel>
                            <Select
                              value={
                                formikCustom.values?.alternateUnitImperialUOM
                                  ? formikCustom.values
                                      ?.alternateUnitImperialUOM
                                  : ''
                              }
                              onChange={formikCustom.handleChange}
                              label="AUoM"
                              inputProps={{
                                name: 'alternateUnitImperialUOM',
                                id: 'outlined-UoM',
                              }}
                              IconComponent={KeyboardArrowDownIcon}
                            >
                              <MenuItem value={'Select AUOM'} disabled selected>
                                Select AUOM
                              </MenuItem>
                              {props?.conversationDataTwo?.map(
                                (item, index) => (
                                  // item?.short_code + " " + item?.unit_name !==
                                  // formikCustom.values?.mainUnitMatricUOM ? (
                                  <MenuItem
                                    key={index}
                                    value={item?.conversion_to_short_code}
                                    onClick={(e) =>
                                      onChangeuAomImperial(e, item)
                                    }
                                  >
                                    {item.conversion_to_short_code}
                                  </MenuItem>
                                )
                                // ) : null
                              )}
                            </Select>
                            {formikCustom.errors?.alternateUnitImperialUOM &&
                            formikCustom.touched?.alternateUnitImperialUOM ? (
                              <div className="pho_14_regular text-danger">
                                {formikCustom.errors?.alternateUnitImperialUOM}
                              </div>
                            ) : null}
                          </FormControl>
                        </Col>
                        <Col
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          className="text-center"
                        >
                          <img
                            src={require('../../../../../../../../assets/images/Icon/openBracket.png')}
                            alt="Imperial System"
                            title="Imperial System"
                            className="img-fluid rotted-images-cs"
                          />
                          <h3 className="f10-400 my-2">(Imperial System)</h3>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="py-4">
                    <Col xs={6} md={4}>
                      <AddButtonIconComponent
                        buttonText="Save"
                        fontIcon="fa fa-plus"
                        colorCss="blue"
                        type="button"
                        onClick={(e) => alternateUnitSave(e)}
                      />
                    </Col>
                    <Col xs={6} md={5}>
                      <AddButtonIconComponent
                        buttonText="Save and Add Another"
                        fontIcon="fa fa-plus"
                        colorCss="blue"
                        type="button"
                        onClick={(e) => alternateUnitSaveAddAnother(e)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    {formikCustom.values?.alternateUnitArr?.length >= 1 ? (
                      <div className="table-responsive">
                        <table className="table table-hover f10-500">
                          <thead>
                            <tr>
                              <th scope="col">Matric Serving Size</th>
                              <th scope="col">Matric UOM</th>
                              <th scope="col">Imperial Serving Size</th>
                              <th scope="col">Imperial UOM</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {formikCustom.values?.alternateUnitArr.map(
                              (item, index) => {
                                return (
                                  <tr key={index}>
                                    <td
                                      className="py-0"
                                      style={{ verticalAlign: 'middle' }}
                                    >
                                      {item?.alternateUnitMatricServingPax}
                                    </td>
                                    <td
                                      className="py-0"
                                      style={{ verticalAlign: 'middle' }}
                                    >
                                      {item?.alternateUnitMatricUOM}
                                    </td>
                                    <td
                                      className="py-0"
                                      style={{ verticalAlign: 'middle' }}
                                    >
                                      {item?.alternateUnitImperialServingPax}
                                    </td>
                                    <td
                                      className="py-0"
                                      style={{ verticalAlign: 'middle' }}
                                    >
                                      {item?.alternateUnitImperialUOM}
                                    </td>
                                    <td
                                      className="py-0"
                                      style={{ verticalAlign: 'middle' }}
                                    >
                                      <IconButton>
                                        <Image
                                          src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                          alt="delete image"
                                          title="delete item"
                                          className="w-20px p-0"
                                          onClick={(e) =>
                                            alternateUnitDeleteIcon(e, index)
                                          }
                                        />
                                      </IconButton>
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </table>
                      </div>
                    ) : null}
                  </Row>
                </Col>
              </Row>
              <Row>
                {/* <Col>
                  <button
                    className="w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_point f12-500 justify-content-center"
                    style={{ color: "#EE3A23" }}
                    title="Save"
                    type="button"
                    // onClick={this.onAddMoreContactHandler}
                  >
                    Save
                  </button>
                </Col> */}
                <Col>
                  <button
                    className="w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_point f12-500 justify-content-center"
                    style={{ color: '#EE3A23' }}
                    title="Save And Add Another"
                    type="button"
                    onClick={(e) => onClickAddNew(e)}
                  >
                    Save And Add Another
                  </button>
                </Col>
                <Col></Col>
              </Row>

              {/* <div className="pb-4">
                <AddButtonIconComponent
                  buttonText="Save and Add Another"
                  fontIcon="fa fa-plus"
                  colorCss="blue"
                  onClick={(e) => onClickAddNew(e)}
                />
              </div> */}
              <hr />
              <Row style={{ wordBreak: 'break-word' }}>
                <Col md={2} xs={2} className="pb-4">
                  <div className="f11-700">Available</div>
                </Col>
                <Col md={2} xs={2} className="pb-4">
                  <div className="f11-700">Set Default</div>
                </Col>
                <Col md={2} xs={2} className="pb-4">
                  <div className="f11-700"> Size Description</div>
                </Col>
                <Col md={2} xs={2} className="pb-4">
                  <div className="f11-700"> Item Price </div>
                </Col>
                <Col md={2} xs={2} className="pb-3">
                  <div className="f11-700">Action</div>
                </Col>

                <Col md={2} xs={2} className="pb-3">
                  {formik.values.size?.length > 0 ? (
                    <button
                      type="button"
                      className={
                        'add-button-icon-reusable add-button-icon-reusable-blue'
                      }
                      onClick={handleShowDetails}
                    >
                      See more
                    </button>
                  ) : (
                    <> </>
                  )}
                  <Modal
                    show={showDetails}
                    onHide={handleCloseDetails}
                    centered
                    size="xl"
                  >
                    <Modal.Header className="px-4 border-0" closeButton>
                      <Modal.Title className="f20-700">
                        Saved Size Description
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="px-4">
                      <Media query="(min-width: 992px)">
                        <div className="enGrayBorderBox mb-3">
                          <div className="table-responsive">
                            <table className="enMinWidth900 w-100 table m-0">
                              <tr>
                                <td>
                                  <div className="f11-400  pb-2">Available</div>
                                </td>
                                <td>
                                  <div className="f11-400  pb-2">
                                    Set Default
                                  </div>
                                </td>
                                <td>
                                  <div className="f11-400  pb-2">
                                    Size Description
                                  </div>
                                </td>
                                <td>
                                  <div className="f11-400 pb-2">Item Price</div>
                                </td>
                                <td>
                                  <div className="f11-400 pb-2">
                                    Serving PAX
                                  </div>
                                </td>
                                <td>
                                  <div className="f11-400 pb-2">Units</div>
                                </td>
                                <td>
                                  <div className="f11-400 pb-2">Measure</div>
                                </td>
                                <td>
                                  <div className="f11-400 pb-2">Action</div>
                                </td>
                              </tr>
                              {formik.values.size.map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    <Form.Check
                                      label="1"
                                      inline
                                      className="enCheckBoxOnly d-grid"
                                      checked={item.available}
                                      onChange={(e) =>
                                        onChangeAvaiblity(item.available, index)
                                      }
                                    />
                                  </td>
                                  <td>
                                    <label className="enRadioWithText small d-grid">
                                      <input
                                        type="radio"
                                        name="setDefault"
                                        checked={item.isDefault}
                                        onChange={(e) => onChangeDefault(index)}
                                      />
                                      <span className="checkmark"></span>
                                    </label>
                                  </td>
                                  <td>
                                    <div className="f12-700">
                                      {item.description}
                                    </div>
                                  </td>
                                  <td>
                                    <input
                                      type="text"
                                      value={item.price}
                                      className="enPriceInput"
                                    />
                                  </td>
                                  <td>
                                    <div className="f12-700">{item.pax}</div>
                                  </td>
                                  <td colspan="2">
                                    <h3 className="col-12 f12-500 p-0 mb-2">
                                      Main Unit of Measurement :
                                    </h3>
                                    <div className="row f11-500 mb-1">
                                      <div className="col-6">Metric System</div>
                                      <div className="col-6">
                                        Imperial System
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-3">
                                        <h3 className="f10-400 mb-1">
                                          Serving Pax:{' '}
                                          {item?.mainUnitMatricServingPax}
                                        </h3>
                                      </div>
                                      <div className="col-3">
                                        <h3 className="f10-400">
                                          UOM: {item?.mainUnitMatricUOM}
                                        </h3>
                                      </div>
                                      <div className="col-3">
                                        <h3 className="f10-400 mb-1">
                                          Serving Pax:{' '}
                                          {item?.mainUnitImperialServingPax}
                                        </h3>
                                      </div>
                                      <div className="col-3">
                                        <h3 className="f10-400">
                                          UOM: {item?.mainUnitImperialUOM}
                                        </h3>
                                      </div>
                                    </div>
                                    <h3 className="col-12 f12-500 p-0 my-2">
                                      Main Unit of Measurement :
                                    </h3>
                                    <div className="row f11-500 mb-1">
                                      <div className="col-6">Metric System</div>
                                      <div className="col-6">
                                        Imperial System
                                      </div>
                                    </div>
                                    {item?.alternateUnitArr &&
                                      item?.alternateUnitArr.map(
                                        (unit, index) => {
                                          return (
                                            <React.Fragment key={index}>
                                              <div className="row">
                                                <div className="col-3">
                                                  <h3 className="f10-400 mb-1">
                                                    Serving Pax:{' '}
                                                    {
                                                      unit?.alternateUnitMatricServingPax
                                                    }
                                                  </h3>
                                                </div>
                                                <div className="col-3">
                                                  <h3 className="f10-400">
                                                    UOM:{' '}
                                                    {
                                                      unit?.alternateUnitMatricUOM
                                                    }
                                                  </h3>
                                                </div>
                                                <div className="col-3">
                                                  <h3 className="f10-400 mb-1">
                                                    Serving Pax:{' '}
                                                    {
                                                      unit?.alternateUnitImperialServingPax
                                                    }
                                                  </h3>
                                                </div>
                                                <div className="col-3">
                                                  <h3 className="f10-400">
                                                    UOM:{' '}
                                                    {
                                                      unit?.alternateUnitImperialUOM
                                                    }
                                                  </h3>
                                                </div>
                                              </div>
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                  </td>
                                  <td>
                                    <div className="d-flex align-itmes-center mt-2">
                                      <IconButton className="mr-2 p-0">
                                        <Image
                                          src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                          alt="edit image"
                                          title="edit"
                                          className="w-20px"
                                          onClick={(e) =>
                                            onEditItem(index, item)
                                          }
                                        />
                                      </IconButton>
                                      <IconButton className="p-0">
                                        <Image
                                          src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                          alt="delete image"
                                          title="delete item"
                                          className="w-20px"
                                          onClick={(e) =>
                                            onClickDeleteIcon(e, index)
                                          }
                                        />
                                      </IconButton>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </table>
                          </div>
                        </div>
                      </Media>
                      <Media query="(max-width: 991px)">
                        <>
                          {formik.values.size.map((item, index) => (
                            <div
                              className="enGrayBorderBox px-3 mb-3"
                              key={index}
                            >
                              <Row>
                                <Col xs={3} className="py-2">
                                  <div className="f10-400 mb-2">Available</div>
                                  <Form.Check
                                    label="1"
                                    inline
                                    className="enCheckBoxOnly d-grid"
                                    checked={item.available}
                                    onChange={(e) =>
                                      onChangeAvaiblity(item.available, index)
                                    }
                                  />
                                </Col>
                                <Col xs={4} className="py-2">
                                  <div className="f10-400 mb-2">
                                    Set Default
                                  </div>
                                  <label className="enRadioWithText small d-grid">
                                    <input
                                      type="radio"
                                      name="setDefault"
                                      checked={item.isDefault}
                                      onChange={(e) => onChangeDefault(index)}
                                    />
                                    <span className="checkmark"></span>
                                  </label>
                                </Col>
                                <Col xs={5} className="py-2">
                                  <div className="f10-400 mb-2">
                                    Add description
                                  </div>
                                  <div className="f10-700">
                                    {item.description}
                                  </div>
                                </Col>
                                <Col xs={12}>
                                  <hr />
                                </Col>
                                <Col xs={4} className="py-2">
                                  <div className="f10-400 mb-2">Item Price</div>
                                  <input
                                    type="text"
                                    value={item.price}
                                    className="enPriceInput"
                                  />
                                </Col>
                                <Col xs={4} className="py-2">
                                  <div className="f10-400 mb-2">
                                    Serving PAX
                                  </div>
                                  <div className="f10-700">{item.pax}</div>
                                </Col>
                                <Col xs={4} className="py-2">
                                  <div className="f10-400 mb-2">Units</div>
                                  <div className="f10-700">{item.size}</div>
                                </Col>
                                <Col xs={12}>
                                  <hr />
                                </Col>
                                <Col xs={4} className="py-2">
                                  <div className="f10-400 mb-2">Measure</div>
                                  <div className="f10-700">{item.uom}</div>
                                </Col>
                                <Col xs={8} className="py-2">
                                  <div className="f10-400 mb-2">Actions</div>
                                  <div className="d-flex align-itmes-center">
                                    <IconButton className="mr-2 p-0">
                                      <Image
                                        src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                                        alt="edit image"
                                        title="edit"
                                        className="w-20px"
                                        onClick={(e) => onEditItem(index, item)}
                                      />
                                    </IconButton>
                                    <IconButton className="p-0">
                                      <Image
                                        src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                                        alt="delete image"
                                        title="delete item"
                                        className="w-20px"
                                        onClick={(e) =>
                                          onClickDeleteIcon(e, index)
                                        }
                                      />
                                    </IconButton>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          ))}
                        </>
                      </Media>
                    </Modal.Body>
                  </Modal>
                </Col>
              </Row>
              {formik.values.size.map((item, index) => (
                <Row className="align-items-center" key={index}>
                  <Col md={12}>
                    <hr className="my-1" />
                  </Col>
                  <Col md={2} xs={2} className="pb-3">
                    <Form.Check
                      label="1"
                      inline
                      className="enCheckBoxOnly d-grid"
                      checked={item.available}
                      onChange={(e) => onChangeAvaiblity(item.available, index)}
                    />
                  </Col>
                  <Col xs={2} className="pb-3">
                    <label className="enRadioWithText small d-grid">
                      <input
                        type="radio"
                        name="setDefault"
                        checked={item.isDefault}
                        onChange={(e) => onChangeDefault(index)}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </Col>
                  <Col md={2} xs={2} className="pb-3">
                    <div className="f11-400">{item.description}</div>
                  </Col>{' '}
                  <Col md={2} xs={2} className="pb-3">
                    <div className="f11-400">{item.price}</div>
                  </Col>
                  <Col md={3} xs={2} className="pb-3">
                    <div
                      className="d-flex align-itmes-center mt-2"
                      style={{ marginBottom: '40px' }}
                    >
                      <IconButton className="mr-2 p-0">
                        <Image
                          src={require('../../../../../../../../assets/images/UserManagement/editBlue.svg')}
                          alt="edit image"
                          title="edit"
                          className="w-20px"
                          onClick={(e) => onEditItem(index, item)}
                        />
                      </IconButton>
                      <IconButton className="p-0">
                        <Image
                          src={require('../../../../../../../../assets/images/UserManagement/delete-gray.svg')}
                          alt="delete image"
                          title="delete item"
                          className="w-20px"
                          onClick={(e) => onClickDeleteIcon(e, index)}
                        />
                      </IconButton>
                    </div>
                  </Col>
                </Row>
              ))}
            </>
          ) : (
            <> </>
          )}
        </>
        {/* <div className="f14-700 mb-3">Metric System</div>
        <Row>
          <Col
            xs={12}
            md={4}
            className="pr-1  input-number-field-with-up-down-arrows"
          >
            <NewInputText
              labelText="Serving Size"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              inputType="number"
              // extraClass={`mb-1 ${
              //   formik.errors &&
              //   formik.errors.sizes &&
              //   formik.errors.sizes[0] &&
              //   formik.errors.sizes[0].size &&
              //   formik.touched &&
              //   formik.touched.sizes &&
              //   formik.touched.sizes[0] &&
              //   formik.touched.sizes[0].size
              //     ? "enError"
              //     : ""
              // }`}
              // name="sizes[0].size"
              // onChange={(e) => {
              //   if (e.target.value >= 0) {
              //     formik.handleChange(e);
              //   }
              // }}
              // value={
              //   formik.values &&
              //   formik.values.sizes &&
              //   formik.values.sizes[0].size
              //     ? formik.values.sizes[0].size
              //     : 0
              // }
              // onFocusOut={formik.handleBlur}
            />
            {/* {formik.errors.size &&
            formik.touched &&
            formik.touched.sizes &&
            formik.touched.sizes[0] &&
            formik.touched.sizes[0].size ? (
              <div className="pho_14_regular text-danger">
                {formik.errors.size}
              </div>
            ) : null} *
          </Col>
          <Col xs={12} md={5} className="p-0 pr-1">
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel htmlFor="outlined-UoM">UoM</InputLabel>
              <Select
                // value={state.UoM}
                // onChange={selecthandleChange}
                label="UoM"
                inputProps={{
                  name: "UoM",
                  id: "outlined-UoM",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                {/* <MenuItem value={"Plate"}>Plate</MenuItem>
                      <MenuItem value={"Bowl"}>Bowl</MenuItem>
                      <MenuItem value={"KG"}>KG</MenuItem> *
                {props.uom_info.map((item, index) => (
                  <MenuItem key={index} value={item.title}>
                    {item.title} {item.description}
                  </MenuItem>
                ))}
              </Select>
              {/* {formik.errors.uom &&
              formik.touched &&
              formik.touched.sizes &&
              formik.touched.sizes[0] &&
              formik.touched.sizes[0].uom ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.uom}
                </div>
              ) : null} *
            </FormControl>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={4}
            className="pr-1 input-number-field-with-up-down-arrows"
          >
            <NewInputText
              labelText="Alternate Serving Size"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              inputType="number"
              // extraClass={`mb-1 ${
              //   formik.errors &&
              //   formik.errors.sizes &&
              //   formik.errors.sizes[0] &&
              //   formik.errors.sizes[0].size &&
              //   formik.touched &&
              //   formik.touched.sizes &&
              //   formik.touched.sizes[0] &&
              //   formik.touched.sizes[0].size
              //     ? "enError"
              //     : ""
              // }`}
              // name="sizes[0].size"
              // onChange={(e) => {
              //   if (e.target.value >= 0) {
              //     formik.handleChange(e);
              //   }
              // }}
              // value={
              //   formik.values &&
              //   formik.values.sizes &&
              //   formik.values.sizes[0].size
              //     ? formik.values.sizes[0].size
              //     : 0
              // }
              // onFocusOut={formik.handleBlur}
            />
            {/* {formik.errors.size &&
            formik.touched &&
            formik.touched.sizes &&
            formik.touched.sizes[0] &&
            formik.touched.sizes[0].size ? (
              <div className="pho_14_regular text-danger">
                {formik.errors.size}
              </div>
            ) : null} *
          </Col>
          <Col xs={12} md={5} className="p-0 pr-1">
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel htmlFor="outlined-UoM">AUoM</InputLabel>
              <Select
                // value={state.UoM}
                // onChange={selecthandleChange}
                label="UoM"
                inputProps={{
                  name: "UoM",
                  id: "outlined-UoM",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                {/* <MenuItem value={"Plate"}>Plate</MenuItem>
                      <MenuItem value={"Bowl"}>Bowl</MenuItem>
                      <MenuItem value={"KG"}>KG</MenuItem> *
                {props.uom_info.map((item, index) => (
                  <MenuItem key={index} value={item.title}>
                    {item.title} {item.description}
                  </MenuItem>
                ))}
              </Select>
              {/* {formik.errors.uom &&
              formik.touched &&
              formik.touched.sizes &&
              formik.touched.sizes[0] &&
              formik.touched.sizes[0].uom ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.uom}
                </div>
              ) : null} *
            </FormControl>
          </Col>
        </Row>
        <Row>
          <Col xs={6} md={4} className="pr-1">
            <div className="pb-4">
              <AddButtonIconComponent
                buttonText="Save UoM"
                fontIcon="fa fa-plus"
                colorCss="blue"
                onClick={(e) => {}}
              />
            </div>
          </Col>
          <Col xs={6} md={5} className="pr-1">
            <div className="pb-4">
              <AddButtonIconComponent
                buttonText="Save and Add Another UoM"
                fontIcon="fa fa-plus"
                colorCss="blue"
                onClick={(e) => {}}
              />
            </div>
          </Col>
        </Row>
        <div className="f14-700 mb-3">Imperial System</div>
        <Row>
          <Col
            xs={12}
            md={4}
            className="pr-1  input-number-field-with-up-down-arrows"
          >
            <NewInputText
              labelText="Serving Size"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              inputType="number"
              // extraClass={`mb-1 ${
              //   formik.errors &&
              //   formik.errors.sizes &&
              //   formik.errors.sizes[0] &&
              //   formik.errors.sizes[0].size &&
              //   formik.touched &&
              //   formik.touched.sizes &&
              //   formik.touched.sizes[0] &&
              //   formik.touched.sizes[0].size
              //     ? "enError"
              //     : ""
              // }`}
              // name="sizes[0].size"
              // onChange={(e) => {
              //   if (e.target.value >= 0) {
              //     formik.handleChange(e);
              //   }
              // }}
              // value={
              //   formik.values &&
              //   formik.values.sizes &&
              //   formik.values.sizes[0].size
              //     ? formik.values.sizes[0].size
              //     : 0
              // }
              // onFocusOut={formik.handleBlur}
            />
            {/* {formik.errors.size &&
            formik.touched &&
            formik.touched.sizes &&
            formik.touched.sizes[0] &&
            formik.touched.sizes[0].size ? (
              <div className="pho_14_regular text-danger">
                {formik.errors.size}
              </div>
            ) : null} *
          </Col>
          <Col xs={12} md={5} className="p-0 pr-1">
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel htmlFor="outlined-UoM">UoM</InputLabel>
              <Select
                // value={state.UoM}
                // onChange={selecthandleChange}
                label="UoM"
                inputProps={{
                  name: "UoM",
                  id: "outlined-UoM",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                {/* <MenuItem value={"Plate"}>Plate</MenuItem>
                      <MenuItem value={"Bowl"}>Bowl</MenuItem>
                      <MenuItem value={"KG"}>KG</MenuItem> *
                {props.uom_info.map((item, index) => (
                  <MenuItem key={index} value={item.title}>
                    {item.title} {item.description}
                  </MenuItem>
                ))}
              </Select>
              {/* {formik.errors.uom &&
              formik.touched &&
              formik.touched.sizes &&
              formik.touched.sizes[0] &&
              formik.touched.sizes[0].uom ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.uom}
                </div>
              ) : null} *
            </FormControl>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={4}
            className="pr-1  input-number-field-with-up-down-arrows"
          >
            <NewInputText
              labelText="Alternate Serving Size"
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              inputType="number"
              // extraClass={`mb-1 ${
              //   formik.errors &&
              //   formik.errors.sizes &&
              //   formik.errors.sizes[0] &&
              //   formik.errors.sizes[0].size &&
              //   formik.touched &&
              //   formik.touched.sizes &&
              //   formik.touched.sizes[0] &&
              //   formik.touched.sizes[0].size
              //     ? "enError"
              //     : ""
              // }`}
              // name="sizes[0].size"
              // onChange={(e) => {
              //   if (e.target.value >= 0) {
              //     formik.handleChange(e);
              //   }
              // }}
              // value={
              //   formik.values &&
              //   formik.values.sizes &&
              //   formik.values.sizes[0].size
              //     ? formik.values.sizes[0].size
              //     : 0
              // }
              // onFocusOut={formik.handleBlur}
            />
            {/* {formik.errors.size &&
            formik.touched &&
            formik.touched.sizes &&
            formik.touched.sizes[0] &&
            formik.touched.sizes[0].size ? (
              <div className="pho_14_regular text-danger">
                {formik.errors.size}
              </div>
            ) : null} *
          </Col>
          <Col xs={12} md={5} className="p-0 pr-1">
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel htmlFor="outlined-UoM">AUoM</InputLabel>
              <Select
                // value={state.UoM}
                // onChange={selecthandleChange}
                label="UoM"
                inputProps={{
                  name: "UoM",
                  id: "outlined-UoM",
                }}
                IconComponent={KeyboardArrowDownIcon}
              >
                {/* <MenuItem value={"Plate"}>Plate</MenuItem>
                      <MenuItem value={"Bowl"}>Bowl</MenuItem>
                      <MenuItem value={"KG"}>KG</MenuItem> *
                {props.uom_info.map((item, index) => (
                  <MenuItem key={index} value={item.title}>
                    {item.title} {item.description}
                  </MenuItem>
                ))}
              </Select>
              {/* {formik.errors.uom &&
              formik.touched &&
              formik.touched.sizes &&
              formik.touched.sizes[0] &&
              formik.touched.sizes[0].uom ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.uom}
                </div>
              ) : null} *
            </FormControl>
          </Col>
        </Row>
        <Row>
          <Col xs={6} md={4} className="pr-1">
            <div className="pb-4">
              <AddButtonIconComponent
                buttonText="Save UoM"
                fontIcon="fa fa-plus"
                colorCss="blue"
                onClick={(e) => {}}
              />
            </div>
          </Col>
          <Col xs={6} md={5} className="pr-1">
            <div className="pb-4">
              <AddButtonIconComponent
                buttonText="Save and Add Another UoM"
                fontIcon="fa fa-plus"
                colorCss="blue"
                onClick={(e) => {}}
              />
            </div>
          </Col>
        </Row> */}
        <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} centered>
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Are you sure to delete this item ?
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={handleCloseDeleteModal}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              onClick={(e) => handleDeleteModal(e)}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="onboarding-map-setup-screen-autodetect-button mt-5">
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="btn-lg btn btn-outline-secondary"
            buttonText="Back"
            buttonType="button"
            onClick={() => onClickBack()}
          />
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
            buttonText="Save and Next"
            buttonType="button"
            // onClick={onSubmit}
            onClick={(e) => OnClickNextStep(e)}
          />
        </div>
      </Form>
    </React.Fragment>
  );
};

SizePricing.propTypes = {
  auth: PropTypes.object.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
  admin_get_all_uom: PropTypes.func.isRequired,
  admin_uom_ratio_filter_search: PropTypes.func.isRequired,
  admin_uom_ratio_filter_searchTwo: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  uom_info: state.category && state.category.uom_info,
  menuCategoryItems: state.onboarding && state.onboarding.menuCategoryItems,
  activeItemId: state.onboarding && state.onboarding.activeItemId,
  nutrition_information:
    state.onboarding.restaurantDetails.nutrition_information,
  productClassification:
    state.onboarding && state.onboarding.set_product_classification,
  uomManagement: state?.uomRatioManagement?.getAllUom?.data,
  conversationData: state?.uomRatioManagement?.getAllUomRatio?.data,
  conversationDataTwo: state?.uomRatioManagement?.getAllUomRatioTwo?.data,
  activeItemData: state.onboarding && state.onboarding.activeItemIdata,
});

export default connect(mapStateToProps, {
  update_item_menu_setup,
  admin_uom_ratio_filter_search,
  admin_uom_ratio_filter_searchTwo,
})(SizePricing);
